import { Box, Button, Grid, Hidden, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Login } from '../login/Login'
import { showCurrency } from './Dashboard'
import { LatestAlerts } from './LatestAlerts'

export const PublicDashboard = ({ user, setUser }) => {
    const [activeUsersSummary, setActiveUsersSummary] = useState()
    const isUserLoggedIn = Object.keys(user).length > 0
    const history = useHistory()
    if (isUserLoggedIn)
        history.push('/dashboard')

    useEffect(() => {
        fetch('/algo-trading/public/api/active-users-combined-summary')
            .then(r => {
                if (r.status >= 400) {
                    history.push('/')
                    return
                }
                r.text()
                    .then(value => {
                        setActiveUsersSummary(JSON.parse(value));
                    })
            }
            ).catch(error => {
                console.log(error);
                history.push('/')
            });
    }, [])

    return (
        <>
            <Grid container display='flex' direction='column' alignItems='center' gap={10} paddingTop={4}
                sx={{
                    backgroundImage: 'url(background.jpeg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '130dvh'
                }}>
                {!isUserLoggedIn &&
                    <Hidden mdUp>
                        <Grid container display='flex' direction='column' gap={2} alignItems='center'>
                            <Grid item>
                                <Login user={user} setUser={setUser} />
                            </Grid>
                            <Grid item>
                                <Link to='/signup'><Button variant='contained' color='info'>Sign Up</Button></Link>
                            </Grid>
                        </Grid>
                    </Hidden>
                }
                <Grid container justifyContent='center'>
                    <Paper component={Grid} item display='flex' flexDirection={'row'} justifyContent='center'
                        lg={4} md={5} sm={8} xs={10}
                        padding={2}>
                        <Typography align='center' sx={{ fontSize: '15px !important' }}>
                            We are not SEBI registered. The information provided here is for education purposes only.
                            We will not be responsible for any of your profit/loss with data shared on this channel.
                            Consult your financial advisor before taking any decision.
                        </Typography>
                    </Paper>
                </Grid>
                <Grid container justifyContent='space-around' alignItems='center' gap={2}>
                    {activeUsersSummary?.totalInvestment &&
                        <>
                            <Grid item>
                                <Paper component={Grid} item elevation={4} style={{ padding: 20 }} alignContent='space-around'>
                                    <Grid item>
                                        <Hidden smDown>
                                            <Typography align='center' variant='h2'>{showCurrency(activeUsersSummary?.totalInvestment)}</Typography>
                                        </Hidden>
                                        <Hidden smUp>
                                            <Typography align='center' variant='h4'>{showCurrency(activeUsersSummary?.totalInvestment)}</Typography>
                                        </Hidden>
                                    </Grid>
                                    <Grid item>
                                        <Typography align='center'>Total Invested Amount</Typography>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Paper component={Grid} elevation={10} item lg={6} md={8} sm={10} xs={11}>
                                <LatestAlerts user={user} />
                            </Paper>
                        </>
                    }
                </Grid>
                <Hidden mdDown ><Box margin={5}></Box></Hidden>
                <Paper sx={{
                    marginTop: 'calc(10% + 60px)',
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                }} component={Grid} item elevation={10}>
                    <Grid container display='flex' justifyContent='center' paddingY={1}>
                        <Link to='/privacy-policy'>Privacy Policy</Link>
                    </Grid>
                    <Grid container display='flex' justifyContent='center' >
                        <Typography sx={{ fontSize: '12px !important' }}>Image generated by <a href='https://ideogram.ai'>Ideogram</a></Typography>
                    </Grid>
                </Paper>
            </Grid >
        </>
    )
}
